/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_TeacherInputs */

const da_billing_plan_teacher = /** @type {(inputs: Billing_Plan_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lærer`)
};

/** @type {(inputs: Billing_Plan_TeacherInputs) => LocalizedString} */
const en_billing_plan_teacher = da_billing_plan_teacher;

/**

* @param {Billing_Plan_TeacherInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_teacher = /** @type {((inputs?: Billing_Plan_TeacherInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_TeacherInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_teacher(inputs)
	return /** @type {LocalizedString} */ ("Lærer")
});